import _isEmpty from 'lodash/isEmpty';
import GraphQL from '@app/model/_common/service/GraphQL';
import _get from 'lodash/get';
import { GraphQLError } from 'graphql/error';
import SecurityService from '@app/model/_security/service/SecurityService';
import { GraphQLClient } from 'graphql-request';

export class GraphQLExecutor {

    private static ENDPOINT = process.env.REACT_APP_API_URL + '/graphql';
    public static graphQLClient = new GraphQLClient(GraphQLExecutor.ENDPOINT)

    private static getHeaders = () => {
        return {
            authorization: !!SecurityService.getToken() ? `Bearer ${SecurityService.getToken()}` : ''
        }
    }

    public static execute = <TYPE>(graphql: GraphQL, variables: Record<any, any> | undefined = undefined) => {
        return GraphQLExecutor.executeWithHeaders<TYPE>(graphql, variables, GraphQLExecutor.getHeaders());
    }

    public static executeWithHeaders = <TYPE>(graphql: GraphQL, variables: Record<any, any> | undefined, headers: HeadersInit) => {
        return new Promise<TYPE>((resolve, reject) =>
            GraphQLExecutor.graphQLClient.request<{ [key: string]: TYPE }, Record<any, any>>(graphql.gql, variables, headers)
                .then(r => {
                    resolve(_get(r, graphql.name))
                })
                .catch(e => GraphQLExecutor.handleError(e, reject)))
    }

    private static handleError(e: GraphQLError, reject: any) {
        const status = _get(e, 'response.status');

        const errors = GraphQLExecutor.findErrorMessages(e);
        const error = errors[0] || 'server.exception.unknown';
        if (status === 500) document.location.href = '/sign-in';
        else if (status === 403 || status === 401
            || errors.includes('server.exception.accessdenied')
            || errors.includes('server.exception.tokenexpired')) {
            document.location.href = '/access-denied';
        }
        reject(error);
    }

    public static findErrorMessages = (error: any) => {
        if (!!error && !!error.response && !_isEmpty(error.response.errors)) {
            return error.response.errors.map((e: any) => e.message)
        }
        return [];
    }
}